// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Unified Pagination Styles - Used across Users, Orders, Complaints */
.orders-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 8px 2px;
  margin: 12px 0;
}

.orders-pager-top {
  scroll-margin-top: 100px; /* Учитывает высоту фиксированного навбара при scrollIntoView */
}

.orders-pager-info {
  color: var(--text-secondary);
  font-size: 0.86rem;
  font-weight: 500;
}

.orders-pager-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.orders-pager-nav,
.orders-pager-page {
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--bg-primary);
  color: var(--text-primary);
  transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease;
  min-height: 34px;
  padding: 0 12px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  line-height: 1; /* Fix vertical alignment */
}

.orders-pager-nav:hover:not(:disabled),
.orders-pager-page:hover:not(.active) {
  background: var(--nav-hover-bg);
  border-color: var(--accent-primary);
}

.orders-pager-nav:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.orders-pager-pages {
  display: flex;
  align-items: center;
  gap: 6px;
}

.orders-pager-page {
  min-width: 34px;
  padding: 0 10px;
}

.orders-pager-page.active {
  background: var(--accent-primary-alpha);
  border-color: var(--accent-primary);
  color: var(--accent-primary);
}

.orders-pager-ellipsis {
  color: var(--text-secondary);
  padding: 0 4px;
}

/* Page Size Dropdown */
.pager-size-dropdown {
  position: relative;
  margin-left: 4px;
  display: flex;
  align-items: center;
}

.orders-pager-size {
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--bg-primary);
  color: var(--text-primary);
  transition: background 0.18s ease, border-color 0.18s ease;
  min-height: 34px;
  padding: 0 10px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 54px;
  line-height: normal;
  box-sizing: border-box;
}

.orders-pager-size span {
  display: block;
  line-height: 1;
  position: relative;
  top: 0;
}

.orders-pager-size:hover {
  background: var(--nav-hover-bg);
  border-color: var(--accent-primary);
}

.pager-size-menu {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  background: var(--bg-primary);
  border: 1px solid var(--border-color); /* Added border */
  border-radius: 12px;
  box-shadow: var(--shadow-lg);
  display: flex;
  flex-direction: column;
  min-width: 60px;
  overflow: hidden;
  z-index: 1000;
  padding: 4px;
}

.pager-size-menu.menu-up {
  bottom: calc(100% + 8px);
}

.pager-size-menu.menu-down {
  top: calc(100% + 8px);
}

.pager-size-option {
  padding: 8px 12px;
  background: transparent;
  border: none;
  color: var(--text-primary);
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  border-radius: 8px;
  text-align: center;
  line-height: 1;
}

.pager-size-option:hover {
  background: var(--bg-hover);
  color: var(--accent-primary);
}

.pager-size-option.active {
  background: var(--accent-primary-alpha);
  color: var(--accent-primary);
  font-weight: 700;
}

/* Responsiveness */
@media (max-width: 768px) {
  .orders-pager {
    justify-content: center;
    gap: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/pagination.css"],"names":[],"mappings":"AAAA,sEAAsE;AACtE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB,EAAE,+DAA+D;AAC3F;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,4EAA4E;EAC5E,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc,EAAE,2BAA2B;AAC7C;;AAEA;;EAEE,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,0DAA0D;EAC1D,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,qCAAqC,EAAE,iBAAiB;EACxD,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mDAAmD;EACnD,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE;IACE,uBAAuB;IACvB,SAAS;EACX;AACF","sourcesContent":["/* Unified Pagination Styles - Used across Users, Orders, Complaints */\n.orders-pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 8px 2px;\n  margin: 12px 0;\n}\n\n.orders-pager-top {\n  scroll-margin-top: 100px; /* Учитывает высоту фиксированного навбара при scrollIntoView */\n}\n\n.orders-pager-info {\n  color: var(--text-secondary);\n  font-size: 0.86rem;\n  font-weight: 500;\n}\n\n.orders-pager-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.orders-pager-nav,\n.orders-pager-page {\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease;\n  min-height: 34px;\n  padding: 0 12px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  line-height: 1; /* Fix vertical alignment */\n}\n\n.orders-pager-nav:hover:not(:disabled),\n.orders-pager-page:hover:not(.active) {\n  background: var(--nav-hover-bg);\n  border-color: var(--accent-primary);\n}\n\n.orders-pager-nav:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.orders-pager-pages {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.orders-pager-page {\n  min-width: 34px;\n  padding: 0 10px;\n}\n\n.orders-pager-page.active {\n  background: var(--accent-primary-alpha);\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n}\n\n.orders-pager-ellipsis {\n  color: var(--text-secondary);\n  padding: 0 4px;\n}\n\n/* Page Size Dropdown */\n.pager-size-dropdown {\n  position: relative;\n  margin-left: 4px;\n  display: flex;\n  align-items: center;\n}\n\n.orders-pager-size {\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  transition: background 0.18s ease, border-color 0.18s ease;\n  min-height: 34px;\n  padding: 0 10px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-width: 54px;\n  line-height: normal;\n  box-sizing: border-box;\n}\n\n.orders-pager-size span {\n  display: block;\n  line-height: 1;\n  position: relative;\n  top: 0;\n}\n\n.orders-pager-size:hover {\n  background: var(--nav-hover-bg);\n  border-color: var(--accent-primary);\n}\n\n.pager-size-menu {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color); /* Added border */\n  border-radius: 12px;\n  box-shadow: var(--shadow-lg);\n  display: flex;\n  flex-direction: column;\n  min-width: 60px;\n  overflow: hidden;\n  z-index: 1000;\n  padding: 4px;\n}\n\n.pager-size-menu.menu-up {\n  bottom: calc(100% + 8px);\n}\n\n.pager-size-menu.menu-down {\n  top: calc(100% + 8px);\n}\n\n.pager-size-option {\n  padding: 8px 12px;\n  background: transparent;\n  border: none;\n  color: var(--text-primary);\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n  border-radius: 8px;\n  text-align: center;\n  line-height: 1;\n}\n\n.pager-size-option:hover {\n  background: var(--bg-hover);\n  color: var(--accent-primary);\n}\n\n.pager-size-option.active {\n  background: var(--accent-primary-alpha);\n  color: var(--accent-primary);\n  font-weight: 700;\n}\n\n/* Responsiveness */\n@media (max-width: 768px) {\n  .orders-pager {\n    justify-content: center;\n    gap: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
